import { get, patch, del, post } from '@/shared/utils/api-utils'
import connector from './connector'
import {
  BatchEquipmentSite,
  EquipmentTableData,
  EquipmentSiteTableData,
  IndividualEquipmentInfo,
  SingleEquipmentSite,
} from '@depanneo/types'

const findAllEquipments = async () => {
  return await get<EquipmentTableData[]>('/equipments')
}

const findEquipmentsBySiteId = async (id: string) => {
  return await get<EquipmentSiteTableData[]>(`/equipments/sites/${id}`)
}

const getEquipmentById = async (id: string) => {
  return await get<IndividualEquipmentInfo>(`/equipments/${id}`)
}

const updateEquipment = async (
  id: string,
  data: Partial<IndividualEquipmentInfo>
) => {
  return await patch<IndividualEquipmentInfo, Partial<IndividualEquipmentInfo>>(
    `/equipments/${id}`,
    data
  )
}
const updateEquipmentSite = async (
  id: string,
  siteId: string,
  data: Partial<SingleEquipmentSite>
) => {
  return await patch<SingleEquipmentSite, Partial<SingleEquipmentSite>>(
    `/equipments/${id}/sites/${siteId}`,
    data
  )
}

const batchUpdateEquipmentSite = async (
  id: string,
  data: BatchEquipmentSite
) => {
  return await patch<SingleEquipmentSite[], BatchEquipmentSite>(
    `/equipments/${id}/sites`,
    data
  )
}

const deleteEquipmentDocument = async (
  equipmentId: string,
  documentId: string
) => {
  return await del<void>(`/equipments/${equipmentId}/documents/${documentId}`)
}

const deleteEquipmentSite = async (equipmentId: string, siteId: string) => {
  return await del<void>(`/equipments/${equipmentId}/sites/${siteId}`)
}

const deleteEquipment = async (id: string) =>
  await del<void>(`/equipments/${id}`)

const bulkDeleteEquipments = async (ids: string[]) => {
  return await post<{ deleted: number; total: number }, { ids: string[] }>(
    '/equipments/bulk-delete',
    { ids }
  )
}

const createEquipment = async (data: FormData) => {
  const response = await connector.post<IndividualEquipmentInfo>(
    '/equipments',
    data,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
  )
  return response.data
}

const addEquipmentDocuments = async (equipmentId: string, data: FormData) => {
  const response = await connector.post<void>(
    `/equipments/${equipmentId}/documents`,
    data,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
  )
  return response.data
}

const createEquipmentSite = async (id: string, data: SingleEquipmentSite[]) => {
  const response = await connector.post<SingleEquipmentSite[]>(
    `/equipments/${id}/sites`,
    data
  )
  return response.data
}

export {
  findAllEquipments,
  findEquipmentsBySiteId,
  getEquipmentById,
  updateEquipment,
  updateEquipmentSite,
  batchUpdateEquipmentSite,
  deleteEquipmentDocument,
  deleteEquipmentSite,
  deleteEquipment,
  bulkDeleteEquipments,
  createEquipment,
  addEquipmentDocuments,
  createEquipmentSite,
}
